import { configureStore } from '@reduxjs/toolkit'

import userReducer from '../../user/domain/userSlice';

export default configureStore({
  reducer: {
      user:userReducer,
  },
})